<template>
	<table cellpadding="0" cellspacing="0" width="100%" height="100%">
		<tr height="0%">
			<td>
				<div class="toolbar">
					<el-row>
						<el-col :span="24" :md="24" :sm="24" :xs="24" justify="right">
							<template>
								<el-date-picker class="mr-10"
									style="margin-bottom: 10px !important; width:260px;"
									v-model="selectedDate"
									size="small"
									type="date"
									placeholder="Request date">
								</el-date-picker>
								<el-input
									style="width:150px;"
									class="mb-10"
									size="small"
									prefix-icon="el-icon-phone"
									placeholder="Phone number"
									@keydown.native.enter="searchReport"
									clearable
									v-model="selectedPhone">
								</el-input>
								<el-button-group class="mr-10 ml-10">
									<el-button size="small" class="el-button el-button--primary animated fadeInRight" @click="searchReport">
										<i class="el-icon-search"/>
									</el-button>
								</el-button-group>
							</template>
						</el-col>
					</el-row>
				</div>
				<br>
				<el-pagination
					background
					prev-text="Prev"
					next-text="Next"
					layout="prev, pager, next"
					:page-size="10"
					@current-change="paginateReport"
					:current-page="currentPage"
					:total="totalMessages">
				</el-pagination>
				<br>
			</td>
		</tr>
		<tr>
			<td>
				<div class="scrollable only-y" ref="view" style="height: 100%">
					<el-row :gutter="30">
						<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
							<el-card style="border: none" class="page-header box-card card-base" :body-style="bodyStyle" v-for="(list, index) of reports" :key="index">
								<el-row :gutter="30">
									<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
										<div class="text item white-text">
											<i class="mdi mdi-file" style="font-size: 24px; line-height: 100px"/>
										</div>
									</el-col>
									<el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
										<span class="text item white-text">
											<h2 class="no-m accent-text">{{ list.title }}</h2>
											<p style="font-size: 14px" class="no-m white-text">
												Report filter detail:
												<ul>
													<li>Start date: {{ list.parameter.startDate }}</li>
													<li>End date: {{ list.parameter.endDate }}</li>
													<li>Phone number: {{ list.parameter.number }}</li>
												</ul><br/>
												Request at: {{ format(list.createdAt, "DD MMM YYYY, HH:mm") }}
											</p><br/>
											<a v-if="list.status == 'done'" class="el-button el-button--primary el-button--mini" target="_blank" :href="list.downloadUrl">
												<i class="mdi mdi-download"/> Download
											</a>

											<el-button disabled v-else-if="list.status == 'waiting'" size="mini" type="warning">
												<i class="mdi mdi-history"/> Processing
											</el-button>

											<el-button disabled v-else size="mini" type="danger">
												<i class="mdi mdi-history"/> Failed
											</el-button>
										</span>
									</el-col>
									<el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
										<el-button :loading="loadingDelete" @click="deleteFile(list.session)" v-if="list.status == 'done' || list.status == 'failed'" size="mini" type="text">
											<i class="mdi mdi-delete text-danger" style="font-size: 24px; line-height: 100px; color: lightgrey !important;"/>
										</el-button>
									</el-col>
								</el-row>
							</el-card>

							<el-card v-if="reports.length < 1" style="border: none" class="page-header box-card card-base">
								<p class="text item white-text" align="center">
									<img src="@/assets/images/no_report.png" width="120px"/><br/>
									Files you download will appear here
								</p>
							</el-card>
						</el-col>
					</el-row>
				</div>
			</td>
		</tr>
	</table>
</template>

<script>
import moment from 'moment-timezone'
import api from '../networkClient'
export default {
	name: 'Reports',
	data(){
		return {
			selectedDate: '',
			selectedPhone: '',
			queryDate: '',
			queryNumber: '',
			currentPage: 1,
			totalMessages: 0,
			loading: false,
			loadingDelete: false,
			bodyStyle: {
				padding: "20px"
			},
			reports: [],
			reportLoading: false
		}
	},
	methods: {
		format(date, str){
			return moment(date).format(str)
		},
		async paginateReport(page) {
			this.currentPage = page
			await this.loadData(this.currentPage)
			this.$refs.view.scrollTop = 0
		},
		async searchReport() {
			this.currentPage = 1
			this.queryDate = this.selectedDate? moment(this.selectedDate).toISOString() : ''
			this.queryNumber = this.selectedPhone
			await this.loadData()
			this.$refs.view.scrollTop = 0
		},
		async loadData(page = 1) {
			this.loading = true
			await api({
				method: "get",
				url: "report/list?page=" + page + "&date=" + this.queryDate + "&number=" + this.queryNumber
			}).then(response => {
				var data = response.data
				this.reports = data.data.docs.map(v => {
					v.title = "Report " + v.customerName
					v.downloadUrl = v.url ? v.url.secure_url : null
					return v
				})
				this.totalMessages = data.data.count
			})
			.catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
            })
			this.loading = false
		},
		async deleteFile(session){
			try {
				await this.$confirm(`You will permanently delete this file. Are you sure?`, 'Confirm', {
					confirmButtonText: 'Sure',
					cancelButtonText: 'Cancel',
					dangerouslyUseHTMLString: true,
					type: 'warning',
					center: true
				})
				this.loading = true
				await api({
					method: "delete",
					url: "report/" + session
				}).then(response => {
					if(response.data.ec == 200){
						this.$swal(this.$t('success'), "", "success")
					} else{
						this.$swal(this.$t('error'), "Sorry, delete file failed. Please try again", "error")
					}
				})
				.catch(error => {
					this.$swal(this.$t('error'), error.message, "error")
				})
				this.loadingDelete = false
				this.loadData()
				this.loading = false
			} catch(err){

			}
		}
	},
	created() {
		this.loadData()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>